import React, { useState } from 'react';

export default function BruteHeader() {
  const [open, setOpen] = useState(false);

  return (
    <header className="brute-header">
      <style>{`
        .brute-header {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          z-index: 20;
          height: 64px;
          background: #F4E9DC;
          border-bottom: 3px solid #1A1416;
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 0 32px;
          box-sizing: border-box;
          font-family: 'Syne', system-ui, sans-serif;
        }
        .brute-header * {
          box-sizing: border-box;
        }
        .brute-header__brand {
          display: flex;
          align-items: center;
          gap: 10px;
          text-decoration: none;
        }
        .brute-header__wordmark {
          position: relative;
          font-family: 'Archivo Black', 'Syne', system-ui, sans-serif;
          font-size: 26px;
          letter-spacing: -0.02em;
          color: #1A1416;
          line-height: 1;
          padding-bottom: 4px;
          border-bottom: 4px solid #FF5A1F;
        }
        .brute-header__dot {
          width: 12px;
          height: 12px;
          border-radius: 50%;
          background: #E6197C;
          border: 2px solid #1A1416;
          margin-left: 2px;
          margin-bottom: 10px;
          flex-shrink: 0;
        }
        .brute-header__nav {
          display: flex;
          align-items: center;
          gap: 28px;
        }
        .brute-header__link {
          font-family: 'Syne', system-ui, sans-serif;
          font-weight: 700;
          font-size: 12px;
          text-transform: uppercase;
          letter-spacing: 0.12em;
          color: #1A1416;
          text-decoration: none;
          transition: color 120ms ease;
        }
        .brute-header__link:hover {
          color: #FF5A1F;
        }
        .brute-header__cta {
          font-family: 'Syne', system-ui, sans-serif;
          font-weight: 700;
          font-size: 12px;
          text-transform: uppercase;
          letter-spacing: 0.12em;
          color: #FFF6EC;
          background: #E6197C;
          text-decoration: none;
          padding: 10px 20px;
          border-radius: 999px;
          border: 2px solid #1A1416;
          transition: background 120ms ease, color 120ms ease;
          white-space: nowrap;
        }
        .brute-header__cta:hover {
          background: #FF5A1F;
          color: #1A1416;
        }
        .brute-header__menu-btn {
          display: none;
          font-family: 'Syne', system-ui, sans-serif;
          font-weight: 700;
          font-size: 12px;
          text-transform: uppercase;
          letter-spacing: 0.12em;
          color: #FFF6EC;
          background: #1A1416;
          border: 2px solid #1A1416;
          border-radius: 999px;
          padding: 8px 18px;
          cursor: pointer;
        }
        .brute-header__mobile-panel {
          display: none;
        }
        @media (max-width: 767px) {
          .brute-header {
            height: 56px;
            padding: 0 16px;
          }
          .brute-header__nav {
            display: none;
          }
          .brute-header__menu-btn {
            display: inline-block;
          }
          .brute-header__mobile-panel {
            display: flex;
            flex-direction: column;
            position: fixed;
            top: 56px;
            left: 0;
            right: 0;
            z-index: 19;
            background: #FFF6EC;
            border-bottom: 3px solid #1A1416;
            padding: 16px;
            gap: 18px;
          }
          .brute-header__mobile-panel .brute-header__link {
            font-size: 14px;
          }
          .brute-header__mobile-panel .brute-header__cta {
            text-align: center;
            padding: 12px 20px;
          }
        }
      `}</style>

      <a href="/" className="brute-header__brand" aria-label="Brute home">
        <span className="brute-header__wordmark">BRUTE</span>
        <span className="brute-header__dot" aria-hidden="true" />
      </a>

      <nav className="brute-header__nav" aria-label="Primary">
        <a href="/login" className="brute-header__link">Sign in</a>
        <a href="/sign-up" className="brute-header__cta">Start an authorized test</a>
      </nav>

      <button
        type="button"
        className="brute-header__menu-btn"
        aria-expanded={open}
        aria-controls="brute-header-mobile"
        onClick={() => setOpen((v) => !v)}
      >
        {open ? 'Close' : 'Menu'}
      </button>

      {open && (
        <div id="brute-header-mobile" className="brute-header__mobile-panel">
          <a href="/login" className="brute-header__link" onClick={() => setOpen(false)}>Sign in</a>
          <a href="/sign-up" className="brute-header__cta" onClick={() => setOpen(false)}>Start an authorized test</a>
        </div>
      )}
    </header>
  );
}
